import $ from 'jquery';

$('.nav-toggle').on('click', function (e) {
    e.preventDefault();
    var toggleActiveClass = 'nav-toggle--active';
    var navActiveClass = 'nav--visible';
    if ($(this).hasClass(toggleActiveClass)) {
        $(this).removeClass(toggleActiveClass);
        $('.nav').removeClass(navActiveClass);
        $(this).closest('.header').removeClass('header--nav-open')
        $('.page').removeClass('page--nav-open');
    } else {
        $(this).addClass(toggleActiveClass);
        $('.nav').addClass(navActiveClass);
        $(this).closest('.header').addClass('header--nav-open')
        $('.page').addClass('page--nav-open');
    }
});

$('.nav__link--disabled').on('click', function () {
    $(this).parent().siblings('.nav__list').toggleClass('nav__list--visible');
    $(this).siblings('.nav__toggle').toggleClass('nav__toggle--open');
})

$('.nav__toggle').on('click', function (e) {
    e.preventDefault();
    $(this).parent().siblings('.nav__list').toggleClass('nav__list--visible');
    $(this).toggleClass('nav__toggle--open');
})

$('.nav__link').on('focus', function () {
    if(this.matches(':focus-visible')) {
        $('.nav__page').removeClass('nav__page--focused');
        $(this).closest('.nav__page--level1').addClass('nav__page--focused');
    }

    let $siblings = $(this).closest('.nav__page--level1').siblings();
    $siblings.find('.nav__page').removeClass('nav__page--focused');
    $siblings.find('.nav__list').removeClass('nav__list--visible');
})

$('*').on('focus', function () {
    if($(this).closest('.nav').length === 0) {
        $('.nav__page').removeClass('nav__page--focused');
        $('.nav__list').removeClass('nav__list--visible');
    }
})
